import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = () => {
  const phoneNumber = '902166068027';
  const message = encodeURIComponent('Merhaba, VE PERA İnşaat hakkında bilgi almak istiyorum.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="whatsapp-btn"
      aria-label="WhatsApp ile iletişime geçin"
    >
      <MessageCircle size={28} />
    </a>
  );
};

export default WhatsAppButton;
